import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicLanguageNotSupportedGuard,
  TopicLowAuthorCountGuard,
  TopicIndexNotReadyGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'
import IndexWidgetEmptyResultGuard from './IndexWidgetEmptyResultGuard'
import IndexWidgetCompareInvalidFilterGuard from './IndexWidgetCompareInvalidFilterGuard'
import IndexWidgetBelowThresholdGuard from './IndexWidgetBelowThresholdGuard'

const IndexWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <IndexWidgetCompareInvalidFilterGuard widgetId={widgetId}>
      <TopicInaccessibleGuard widgetId={widgetId}>
        <TopicLanguageNotSupportedGuard widgetId={widgetId}>
          <TopicLowAuthorCountGuard widgetId={widgetId}>
            <TopicIndexNotReadyGuard widgetId={widgetId}>
              <IndexWidgetEmptyResultGuard widgetId={widgetId}>
                <IndexWidgetBelowThresholdGuard widgetId={widgetId}>
                  {children}
                </IndexWidgetBelowThresholdGuard>
              </IndexWidgetEmptyResultGuard>
            </TopicIndexNotReadyGuard>
          </TopicLowAuthorCountGuard>
        </TopicLanguageNotSupportedGuard>
      </TopicInaccessibleGuard>
    </IndexWidgetCompareInvalidFilterGuard>
  </WidgetLoadingGuard>
)

export default IndexWidgetDataGuards
